import { useI18n } from '~/common/context';
import { Flex, Icon, Text, Title, Button } from '@wyz/ui';
import { Link } from 'react-router';
import * as React from 'react';
type ChildrenProps = {
  children: React.ReactNode;
};
type LinkProps = {
  link: {
    label: string;
    to: string;
    id: string;
  };
};
type Props = {
  title?: React.ReactNode;
  subtitle: React.ReactNode;
} & (ChildrenProps | LinkProps);

export function EmptyTable({ title, subtitle, ...rest }: Props) {
  const { t } = useI18n();

  return (
    <Flex direction='column' alignItems='center'>
      <SvgImage />
      <Title heading='xl' weight='bold' color='tertiary' className='mt-5 mb-1'>
        {title || t('app.models.no_models.title')}
      </Title>
      <Title heading='lg' weight='normal' color='secondary' className='mb-4'>
        {subtitle}
      </Title>
      {'link' in rest ? (
        <Button as={Link} to={rest.link.to} variant='primary' id='create'>
          <Icon icon='group' />
          <Text weight='semi-bold' color='inherit' heading='normal'>
            {rest.link.label}
          </Text>
        </Button>
      ) : (
        rest.children
      )}
    </Flex>
  );
}

function SvgImage() {
  return (
    <svg
      width='250'
      height='250'
      viewBox='0 0 320 320'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M284.45 320H36.2197L72.1127 116.439H320.343L284.45 320Z'
        fill='#FABB1E'
      />
      <path
        d='M157.069 95.3563H75.8291L72.1123 116.438H159.053L157.069 95.3563Z'
        fill='#FABB1E'
      />
      <path
        d='M284.45 320H36.2197L72.1127 116.439H320.343L316.601 137.663L308.235 185.11L284.45 320Z'
        fill='#B8C4D1'
      />
      <path
        d='M159.053 116.438H72.1123L75.8291 95.3563H157.069L159.053 116.438Z'
        fill='#B8C4D1'
      />
      <path
        d='M219.151 149.853L102.79 160.759L88.7891 11.387L175.188 3.28943L207.819 28.9421L219.151 149.853Z'
        fill='#D1D8E1'
      />
      <path
        d='M219.956 147.88L103.308 155.1L94.041 5.35893L180.653 -0.000732422L212.456 26.6717L219.956 147.88Z'
        fill='#DDE3E9'
      />
      <path
        d='M180.871 0.547924L212.674 27.2204L182.637 29.0801L180.871 0.547924Z'
        fill='#C1CBD7'
      />
      <path
        d='M156.478 38.159C163.075 37.7277 168.46 39.1096 172.632 42.3046C176.866 45.4955 179.188 50.2357 179.599 56.525C179.978 62.321 178.363 66.978 174.754 70.4958C171.202 73.948 166.314 75.9085 160.091 76.3772L160.082 83.3442L146.208 84.2511L144.621 67.0782L150.171 66.7154C154.918 66.4051 158.487 65.5835 160.877 64.2508C163.329 62.914 164.454 60.7041 164.252 57.6211C164.111 55.463 163.414 53.8056 162.162 52.649C160.91 51.4924 159.236 50.9826 157.139 51.1196C154.92 51.2648 153.235 52.025 152.087 53.4005C150.934 54.7143 150.429 56.4503 150.57 58.6084L135.679 59.5818C135.31 55.8286 135.859 52.3869 137.326 49.2567C138.855 46.1225 141.228 43.5834 144.445 41.6392C147.719 39.6294 151.73 38.4693 156.478 38.159ZM154.902 107.833C152.127 108.014 149.793 107.362 147.9 105.876C146.065 104.324 145.069 102.345 144.912 99.9405C144.751 97.4741 145.479 95.3521 147.096 93.5744C148.776 91.7927 151.003 90.8112 153.777 90.6298C156.49 90.4525 158.765 91.1398 160.6 92.6917C162.497 94.2397 163.526 96.2468 163.687 98.7132C163.844 101.118 163.083 103.211 161.404 104.993C159.782 106.709 157.615 107.656 154.902 107.833Z'
        fill='#C1CBD7'
      />
      <path
        d='M284.086 320H35.3202L0 123.829H248.767L284.086 320Z'
        fill='#CED6DF'
      />
    </svg>
  );
}
